import { StyleSheet } from "react-native"
import { spinnerText } from "constants/Fonts"
import Colors from "constants/Colors"

export default StyleSheet.create({
  container: {
    backgroundColor: Colors.containerBackground,
  },
  spinner: {
    marginTop: 100,
  },
  errorText: {
    textAlign: "center",
    marginTop: 15,
    ...spinnerText,
  },
})
